import styled from 'styled-components';

export const TabContentContainer = styled.div``;

export const TabContentTitleContainer = styled.div`
  margin: ${({ theme }) => `${theme.spacing.xm}`}
    ${({ theme }) => theme.spacing.m} ${({ theme }) => `${theme.spacing.m}`}
    ${({ theme }) => theme.spacing.m};
`;

export const TabContentGridContainer = styled.div`
  margin-bottom: ${({ theme }) => theme.spacing.l};
`;

export const TabsContentCommentsContainer = styled.div`
  margin: ${({ theme }) => `${theme.spacing.l}`}
    ${({ theme }) => theme.spacing.m};
`;
